import styled from 'styled-components';

export default styled.div`
    .manual-acceptance-info {
        text-align: center;
        margin-top: var(--spacing-8);
    }
`;
